import React from 'react'

import InternalServerError from '../images/500.png'
import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'

const useStyles = makeStyles(() => ({
    iconContainer: {
      // width: '60px',
    },
    image: { width: '3.5rem', height: '3.5rem' },
    errorContainer: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: 'auto',
      marginTop: '40px',
    },
    title: {
      fontSize: '1.2rem',
      fontWeight: 500,
      padding: '0.9rem',
      textAlign: 'center',
    },
    subTitle: {
      fontSize: '1rem',
      fontWeight: 400,
      textAlign: 'center',
      '& a': {
        fontSize: '1rem',
      },
    },
}))

const GeneralError = () => {
    const classes = useStyles()
    return  <Box>
    
      <Box style={{textAlign:'center', position:"absolute", top:'40%', left:'45%'}}>
        <img className={classes.image} src={InternalServerError} />
        <Box className={classes.title}>Abbiamo avuto un problema a processare la richiesta</Box>
    <Box className={classes.subTitle}>Riprovare più tardi!</Box>
      </Box>
    

    
  </Box>
}

export default GeneralError